// EmployeeTimeEntryButtons.jsx
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {getUserTimeEntries, updateTimeEntry, createTimeEntry} from "../features/timeentries/timeentrySlice.jsx";
import { getEmployees, updateEmployeeStatus } from "../features/employees/employeeSlice";
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from "../features/auth/authSlice";
import { toast } from "react-toastify";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const EmployeeTimeEntryButtons = ({employeeButtonChoice, handleSetEntryButtonShow, handleSetStatus }) => {
  const now = new Date().toISOString();
  const { user, isSuccessAuth, isErrorAuth} = useSelector((state) => state.auth);
  const { UpdateEntryisSuccess,CreateEntryisSuccess } = useSelector((state) => state.entries);
  const [showButtons, setShowButtons] = useState(true);
  const dispatch = useDispatch();

let caseNumber;
switch (true) {
    case (!employeeButtonChoice.clockedIn && !employeeButtonChoice.onPause):
        caseNumber = 1;   // (Case #1) Object { clockedIn: false, onPause: false } => ClockIn (Case #1)
        break;
    case (employeeButtonChoice.clockedIn && !employeeButtonChoice.onPause):
        caseNumber = 2;  // (Case #2) Object { clockedIn: true, onPause: false } => Clock Out or TakeBreak
        break;
    case (employeeButtonChoice.clockedIn && employeeButtonChoice.onPause):
        caseNumber = 3;  // (Case #3) Object { clockedIn: true, onPause: true }  => EndBreak  and/or ClockOut (leave this for now)
        break;
    default:
        caseNumber = 4;  //otherwise (Case #4) 
        break;
}


  const handleClockOutClick = useCallback(() => {
    // setBadgeStatus('off_clock')
    const entryId = employeeButtonChoice.entryId;
    handleSetStatus("off_clock");
    const updatedData = {
      end_time: now
    };
    handleSetEntryButtonShow(false);
    dispatch(updateEmployeeStatus({ employeeId: user.employeeId, status: 'off_clock' }));
    dispatch(updateTimeEntry({ id: entryId, entryData: updatedData, user }))
    .then(() => {});
    ;
  }, [dispatch, employeeButtonChoice]);

  const handleClockInClick = useCallback(() => {
    // setBadgeStatus('on_clock')
    handleSetStatus("on_clock");
    const updatedData = {
      start_time: now
    };    
    handleSetEntryButtonShow(false);
    dispatch(updateEmployeeStatus({ employeeId: user.employeeId, status: 'on_clock' }));
    dispatch(createTimeEntry({ entryData: updatedData, user }))
    .then(() => {});
    ;
  }, [dispatch, employeeButtonChoice]);

  const handlePauseClick = useCallback(() => {
    // setBadgeStatus('on_pause')
    handleSetStatus("on_pause");
    const entryId = employeeButtonChoice.entryId;
    const updatedData = {
      pause_time: now
    };   
    handleSetEntryButtonShow(false); 
    dispatch(updateEmployeeStatus({ employeeId: user.employeeId, status: 'on_pause' }));
    dispatch(updateTimeEntry({ id: entryId, entryData: updatedData, user }))
    .then(() => {});
    ;
  }, [dispatch, employeeButtonChoice]);

  const handleUnPauseClick = useCallback(() => {
    // setBadgeStatus('on_clock')
    handleSetStatus("on_clock");
    const entryId = employeeButtonChoice.entryId;
    const pause_time = new Date(employeeButtonChoice.paused_time);
    const delta = (new Date() - pause_time)/1000;
    const updatedData = {
      seconds_paused: Math.round(delta + employeeButtonChoice.secondss_paused),
      pause_time: null
    };
    handleSetEntryButtonShow(false);   
    dispatch(updateEmployeeStatus({ employeeId: user.employeeId, status: 'on_clock' }));
    dispatch(updateTimeEntry({ id: entryId, entryData: updatedData, user }))
    .then(() => {});
    ;
  }, [dispatch, employeeButtonChoice]);

  return (
    <Box sx={{ marginTop: 10, flexGrow: 1 }}>
      <Grid
        container
        spacing={6}
        columnSpacing={{ xs: 6, sm: 6, md: 6 }}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
      {showButtons ?
        (() => 
          {
            switch (caseNumber) {
              case 1:
                return (
                  <Grid item xs={5} md={6}>
                    <Item>
                      <Card sx={{ maxWidth: 345, maxHeight: 150, backgroundColor: "green" }}>
                        <CardActionArea onClick={handleClockInClick}>
                          <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                              Clock IN
                            </Typography>
                            <LoginIcon fontSize="large" />
                          </CardContent>
                        </CardActionArea>
                        <CardActions />
                      </Card>
                    </Item>
                  </Grid>
                );
              case 2:
                return (
                  <>
                    <Grid item xs={5} md={6}>
                      <Item>
                        <Card sx={{ maxWidth: 345, maxHeight: 150, backgroundColor: "red" }}>
                          <CardActionArea onClick={handleClockOutClick}>
                            <CardContent>
                              <Typography gutterBottom variant="h5" component="div">
                                Clock OUT
                              </Typography>
                              <ExitToAppIcon fontSize="large" />
                            </CardContent>
                          </CardActionArea>
                          <CardActions />
                        </Card>
                      </Item>
                    </Grid>
                    <Grid item xs={10} md={12}>
                      <Item>
                        <Card sx={{ maxHeight: 150, backgroundColor: "orange" }}>
                          <CardActionArea onClick={handlePauseClick}>
                            <CardContent>
                              <Typography gutterBottom variant="h5" component="div">
                                <FreeBreakfastIcon fontSize="large" />   Take Break
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                          <CardActions />
                        </Card>
                      </Item>
                    </Grid>
                  </>
                );
              case 3:
                return (
                  <Grid item xs={10} md={12}>
                    <Item>
                      <Card sx={{ maxHeight: 150, backgroundColor: "yellow" }}>
                        <CardActionArea onClick={handleUnPauseClick}>
                          <CardContent>
                          <Typography gutterBottom variant="h5" component="div">
                                <FreeBreakfastIcon fontSize="large" />   End Break
                              </Typography>
                          </CardContent>
                        </CardActionArea>
                        <CardActions />
                      </Card>
                    </Item>
                  </Grid>
                );
              default:
                return null;
            }
          }
        )():null
      }
      </Grid>
    </Box>
  );
  
};
export default EmployeeTimeEntryButtons;